import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { claimBarCellMaxWidth } from '~/components/ClaimPage/ClaimPageBar/ClaimPageBarUtils';
import { ContactEntity } from '~/components/Contact';
import { useCms } from '~/components/hooks/useCms';
import { usePolicy } from '~/components/PolicyContainer';
import { getReinsuranceTextIfNeeded, isReinsuranceManagementClaim } from '~/Utils/ClaimUtils';

import GenericClaimBarField from './GenericClaimBarField';

type PolicyHolderProps = {
  displayName?: string;
};

const PolicyHolder = ({ displayName = 'Policyholder' }: PolicyHolderProps) => {
  const { claim } = useClaim();
  const { userOrganization } = useCms();
  const { policy } = usePolicy();

  const isReinsuranceEnabled = isReinsuranceManagementClaim(claim, userOrganization);

  const title = getReinsuranceTextIfNeeded({ key: 'policyholder', isReinsuranceEnabled, defaultText: displayName });

  return (
    <GenericClaimBarField title={title}>
      <ContactEntity
        contactId={policy.insured_contact_id}
        contactDisplayName={policy.insured_contact_full_name}
        maxWidth={claimBarCellMaxWidth}
      />
    </GenericClaimBarField>
  );
};

export default PolicyHolder;
